<template>
  <input
    ref="inputRef"
    class="placeholder:text-navy"
    :name="name"
    type="text"
    placeholder="$"
    @input="$emit('input', numberValue)"
    @change="$emit('change', numberValue)"
  />
</template>

<script setup lang="ts">
import { useCurrencyInput } from "vue-currency-input";
const props = defineProps<{ modelValue?: number; name: string }>();
defineEmits<{ (e: "input" | "change", value: number | null): void }>();

const { inputRef, setValue, numberValue } = useCurrencyInput({
  currency: "USD",
  hideCurrencySymbolOnFocus: false,
  hideGroupingSeparatorOnFocus: false,
  hideNegligibleDecimalDigitsOnFocus: false,
  //@ts-expect-error Type is not exported
  currencyDisplay: "narrowSymbol",
  precision: 2,
});

watch(
  () => props.modelValue,
  (value) => {
    setValue(value ?? null);
  },
);
</script>
